import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomePrice = () => {
  const [PriceTopUser, setPriceTopUser] = useState([]);
  const [PriceUser, setPriceUser] = useState([]);
  const navigate = useNavigate();

  //   Price top api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/getpricetop"
      );
      setPriceTopUser(response.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getprice");
      setPriceUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteprice/${userId}`);

      setPriceUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Price");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {PriceTopUser.map((user) => {
            return (
              <div>
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Price-header-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-btn"></i>
                  </Link>
                </h3>
                <p dangerouslySetInnerHTML={{__html: user.para}}></p>
              </div>
            );
          })}
          <Link to="/Price-add">
            <button className="Banner-button">Add</button>
          </Link>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-2">Title</th>
                  <th className="col-lg-2">Price</th>
                  <th className="col-lg-4">Description</th>
                  <th className="col-lg-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {PriceUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>{user.title}</td>
                      <td>{user.price}</td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{ __html: user.description }}
                        ></p>
                      </td>
                      <td>
                        <Link to={`/Price-view/` + user.id}>
                          <i
                            title="View"
                            className="fa-regular fa-eye action-btn"
                            style={{ color: "blue" }}
                          ></i>
                        </Link>
                        <Link to={`/Price-edit/` + user.id}>
                          <i className="fa-regular fa-pen-to-square action-btn"></i>
                        </Link>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            title="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PriceAdd = () => {
  const [PriceData, setPriceData] = useState({
    title: "",
    price:"",
    description: "",
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setPriceData((prev) => ({ ...prev, [name]: value }));
  };


  const submitForm = async (e) => {
    e.preventDefault();
  
    if (
      !PriceData.title ||
      !PriceData.price ||
      !PriceData.description
    ) {
      toast.error("All fields are required!");
      return;
    }
  
    try {
  
      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createprice", PriceData);
  
      toast.success("Data added successfully!");
      navigate("/Price");
    } catch (error) {
      console.error("Error adding Price:", error);
      toast.error("Failed to add Price!");
    }
  };
  

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/Price">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Price Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={PriceData.title}
                  id="title"
                  name="title"
                  placeholder="Enter Title"
                />
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="price">Price</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={PriceData.price}
                  id="price"
                  name="price"
                  placeholder="Enter Price"
                />
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description">Description</label>
                <textarea
                  onChange={inputHandler}
                  value={PriceData.description}
                  id="description"
                  name="description"
                  placeholder="Enter Description"
                  rows="4"
                ></textarea>
              </div>
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomePriceEdit = () => {
  const [Priceuser, setPriceUser] = useState({
    title: "",
    subtitle: "",
    description: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // Load CKEditor
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) =>
          window.CKEDITOR.instances[instance].destroy(true)
        );
      }
    };
  }, []);

  // Fetch existing data
  const fetchPriceData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getoneprice/${id}`
      );
      if (response.data.success) {
        setPriceUser(response.data.data);
        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Price data!", error);
      toast.error("Failed to load Price data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) fetchPriceData();
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Priceuser.description || "");
    }
  }, [Priceuser.description, editorLoaded]);

  

  // Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setPriceUser({ ...Priceuser, [name]: value });
  };


  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    const PriceData = {
      title : Priceuser.title,
      price : Priceuser.price,
      description: window.CKEDITOR.instances.editor.getData()
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateprice/${id}`,
        PriceData
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Price");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating the Price:", error);
      toast.error("Failed to update Price.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm} encType="multipart/form-data">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Price">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={Priceuser.title}
                  onChange={changeHandler}
                  className="form-control"
                  name="title"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Price</label>
                <input
                  type="text"
                  value={Priceuser.price}
                  onChange={changeHandler}
                  className="form-control"
                  name="price"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea id="editor"></textarea>
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Price">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const HomePriceView = () => {
  const [PriceUser, setPriceUser] = useState({
    title: "",
    subtitle:"",
    description: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const PriceData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneprice/${id}`
        );
        setPriceUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    PriceData();
  }, [id]);

  return (
    <div className="container-fluid admin-view">
      <div className="row arpi">
        <div className="col-lg-3 col-md-3 col-sm-12"></div>

        <div className="col-lg-7 col-md-7 col-sm-12 view-sec">
          <Link to="/Price" className="back-btn">
            <i className="fa-solid fa-arrow-left"></i> Back
          </Link>
          <br />
          <br />

          <h4>
            {PriceUser.title}{" "}
            <Link to={`/Price-edit/` + PriceUser.id}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Link>
          </h4>
          <h6>{PriceUser.price}</h6>

          <br />
          <p dangerouslySetInnerHTML={{ __html: PriceUser.description }}></p>
        </div>
      </div>
    </div>
  );
};

export const PriceHeaderEdit = () => {
  const [Priceuser, setPriceUser] = useState({
    heading: "",
    para: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setPriceUser({ ...Priceuser, [name]: value });
    // console.log(user);
  };

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonepricetop/${id}`
        );
        // console.log(response.data);
        setPriceUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      heading: Priceuser.heading,
      para: Priceuser.para,
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatepricetop/${id}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setPriceUser(formData);
        toast.success("Data updated successfully!");
        navigate("/Price");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit
              </h5>
              <Link to="/Price">
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Priceuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                />
                <br />
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea
                  type="text"
                  value={Priceuser.para}
                  onChange={changeHandler}
                  className="form-control"
                  name="para"
                  rows={3}
                />
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Price">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
